import { render, staticRenderFns } from "./TabsContent.vue?vue&type=template&id=45b28d8a&scoped=true&"
import script from "./TabsContent.vue?vue&type=script&lang=ts&"
export * from "./TabsContent.vue?vue&type=script&lang=ts&"
import style0 from "./TabsContent.vue?vue&type=style&index=0&id=45b28d8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b28d8a",
  null
  
)

export default component.exports